import React from "react";
import { Card } from "flowbite-react";
import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";
import Enderecos from "../../common/query/Enderecos";
import Emails from "../../common/query/Emails";
import Telefones from "../../common/query/Telefones";
import Sociedade from "../../common/query/Sociedade";

const LocalizacaoPJQuery = ({ data }) => {
  return (
    <div className="space-y-10 mt-8">
      {/* DADOS CADASTRAIS */}
      <div>
        <TitleStripe>📄 Dados Cadastrais</TitleStripe>
        <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4 mt-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-sm text-gray-800">
            <div className="space-y-4">
              <div>
                <p className="text-gray-500 text-xs uppercase">Razão Social</p>
                <p className="text-base font-semibold">
                  {data?.razaoSocial || "Indisponível"}
                </p>
              </div>
              <div>
                <p className="text-gray-500 text-xs uppercase">Nome Fantasia</p>
                <p>{data?.nomeFantasia || "Indisponível"}</p>
              </div>
              <div>
                <p className="text-gray-500 text-xs uppercase">
                  Data de Fundação
                </p>
                <p>{data?.dataFundacao || "Indisponível"}</p>
              </div>
            </div>

            <div className="space-y-4">
              <div>
                <p className="text-gray-500 text-xs uppercase">CNPJ</p>
                <p className="text-base font-semibold">
                  {data?.cnpj || "Indisponível"}
                </p>
              </div>
              <div>
                <p className="text-gray-500 text-xs uppercase">Situação</p>
                <span
                  className={`inline-block px-3 py-1 text-xs font-bold rounded-full ${
                    data?.situacao?.toUpperCase() === "ATIVA"
                      ? "bg-green-100 text-green-700"
                      : "bg-red-100 text-red-700"
                  }`}
                >
                  {data?.situacao || "Indisponível"}
                </span>
              </div>
              <div>
                <p className="text-gray-500 text-xs uppercase">
                  Natureza Jurídica
                </p>
                <p>{data?.naturezaJuridica || "Indisponível"}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SEÇÕES DINÂMICAS */}
      {[
        {
          title: "👥 Sócios",
          content: data?.socios,
          component: <Sociedade socios={data?.socios} />,
        },
        {
          title: "📍 Endereços",
          content: data?.enderecos,
          component: <Enderecos enderecos={data?.enderecos} />,
        },
        {
          title: "📧 E-mails",
          content: data?.emails,
          component: <Emails emails={data?.emails} />,
        },
        {
          title: "📞 Telefones",
          content: data?.telefones,
          component: <Telefones telefones={data?.telefones} />,
        },
      ].map(
        ({ title, content, component }, idx) =>
          content && (
            <div key={idx}>
              <TitleStripe>{title}</TitleStripe>

              {content.length > 0 ? component : <NoOcurrence />}
            </div>
          )
      )}
    </div>
  );
};

export default LocalizacaoPJQuery;
